firebird.controller('pollsModalCtrl', [
    '$scope',
    '$window',
    'attendeeService',
    'contentService',
    'logService',
    'meetingService',
    'socketService',
    'pollingService',
    'questionService',
    'brandingService',
    'localizationService',
    function (
        $scope,
        $window,
        attendeeService,
        contentService,
        logService,
        meetingService,
        socketService,
        pollingService,
        questionService,
        brandingService,
        localizationService
    ) {
        var self = this;
        const logger = logService.createLoggerWithSource('pollsModalCtrl');

        self.modalState = 'closed';

        self.currentView = 'list'; // list, create, edit

        // self.votingState            = 'voting-closed';
        // Running
        // voting-started
        // voting-stopped
        // voting-show-results
        // voting-closed

        // Variables
        self.attendantId = attendeeService.getAttendantId();
        self.attendantLoginId = attendeeService.getAttendantLoginId();
        self.isPresenter = attendeeService.getIsPresenter();
        self.polls = [];

        // Create poll model variable
        self.createPollModel = {
            createQuestion: '',
            createAnswer1: '',
            createAnswer2: '',
            createAnswer3: '',
            createAnswer4: '',
            createAnswer5: ''
        };

        // Edit poll model variable
        self.editPollModel = {
            editPollId: null,
            editQuestion: '',
            editAnswer1: '',
            editAnswer2: '',
            editAnswer3: '',
            editAnswer4: '',
            editAnswer5: ''
        };
        self.pollBeingEdited = null;

        self.pollRunning = null;
        self.pollRunningSelectedPollId = null;
        self.canVote = true;
        self.hasVoted = false;
        self.voteSelected = false;

        // Methods
        self.changeView = changeView;
        self.createPoll = createPoll;
        self.deletePoll = deletePoll;
        self.editPoll = editPoll;
        self.getPolls = getPolls;
        self.getVotePercentage = getVotePercentage;
        self.getTotalVotes = getTotalVotes;

        self.pollAnswerSelected = pollAnswerSelected;
        self.runPoll = runPoll;
        self.stopVoting = stopVoting;
        self.editPollHasChanges = editPollHasChanges;
        self.createPollIsValid = createPollIsValid;
        self.editPollIsValid = editPollIsValid;

        self.donePolling = donePolling;

        // Create poll methods
        self.cancelNewPoll = cancelNewPoll;
        self.clearCreatePollFields = clearCreatePollFields;
        self.submitNewPoll = submitNewPoll;

        // Edit poll methods
        self.cancelEditedPoll = cancelEditedPoll;
        self.clearEditPollFields = clearEditPollFields;
        self.submitEditedPoll = submitEditedPoll;

        self.onRefreshPollsList = onRefreshPollsList;
        self.onExistingPollUpdated = onExistingPollUpdated;
        self.onNewPollAdded = onNewPollAdded;
        self.onVotingStarted = onVotingStarted;

        self.canPollBeDeleted = canPollBeDeleted;

        // Display methods
        self.onShowModal = onShowModal;
        self.onHideModal = onHideModal;

        // Display events
        $scope.$on('show-modal', self.onShowModal);
        $scope.$on('hide-modal', self.onHideModal);

        // Other events
        $scope.$on('polls-list', self.onRefreshPollsList);
        $scope.$on('existing-poll-updated', self.onExistingPollUpdated);
        $scope.$on('new-poll-added', self.onNewPollAdded);

        $scope.$on('voting-started', self.onVotingStarted);

        $scope.$on('promoted-to-presenter', onPromotedToPresenter);
        $scope.$on('demoted-to-attendee', onDemotedToAttendee);

        init();

        ////////////////////////

        function init() {
            if (meetingService.isWebinar() === true && attendeeService.getIsPresenter() === true) {
                self.getPolls();
            }
        }

        function onShowModal(e, modalName) {
            if (modalName === 'polls' && attendeeService.getIsPresenter()) {
                self.modalState = 'open';
                digest();
            }
        }

        function onDemotedToAttendee(event) {
            self.onHideModal('onDemotedToAttendee', 'pollsModalCtrl as polls');
        }

        function onPromotedToPresenter(event) {
            self.getPolls();
        }

        function onHideModal(e, modalName) {
            if (modalName === 'pollsModalCtrl as polls') {
                self.modalState = 'closed';
                digest();
            }
        }

        function onRefreshPollsList(e, newPollsList) {
            self.polls = newPollsList;

            digest();
        }

        function onExistingPollUpdated(event) {
            self.changeView('list');
            self.clearEditPollFields();
        }

        function onNewPollAdded(event) {
            self.changeView('list');
            self.clearCreatePollFields();
        }

        function digest() {
            if (!$scope.$$phase) {
                $scope.$digest();
            }
        }

        function getPolls() {
            var self = this;

            var msgObj = {
                message: 'get-polls',
                data: {},
                callback: function (success) {}
            };

            socketService.send(msgObj);
        }

        function onVotingStarted(e, poll, votes) {
            if (poll.pollId === self.editPollModel.editPollId) {
                if (self.editPollHasChanges()) {
                    $window.swal({
                        title: localizationService.translate('POLLS.ANOTHER_PRESENTER_HAS_STARTED_THIS_POLL.TITLE'),
                        text: localizationService.translate('POLLS.ANOTHER_PRESENTER_HAS_STARTED_THIS_POLL.TEXT'),
                        type: 'warning',
                        confirmButtonColor: brandingService.getBaseColor()
                    });
                }
                self.changeView('list');
                self.clearEditPollFields();
            }

            self.onHideModal('onVotingStarted', 'pollsModalCtrl as polls');
        }

        function cancelNewPoll() {
            var self = this;

            // Cancel new poll
            if (
                self.createPollModel.createQuestion ||
                self.createPollModel.createAnswer1 ||
                self.createPollModel.createAnswer2 ||
                self.createPollModel.createAnswer3 ||
                self.createPollModel.createAnswer4 ||
                self.createPollModel.createAnswer5
            ) {
                $window.swal(
                    {
                        title: localizationService.translate('POLLS.DISCARD_POLL.TITLE'),
                        type: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: brandingService.getBaseColor(),
                        cancelButtonText: localizationService.translate('COMMON.CANCEL_TEXT'),
                        confirmButtonText: localizationService.translate('POLLS.DISCARD'),
                        closeOnConfirm: true
                    },
                    function (isConfirm) {
                        if (isConfirm) {
                            logger.log('Call to discard new poll was confirmed');

                            self.changeView('list');

                            self.clearCreatePollFields();
                        } else {
                            logger.log('Call to discard new poll was cancelled');
                        }
                    }
                );
            } else {
                self.changeView('list');
            }
        }

        function canPollBeDeleted(poll) {
            return attendeeService.getIsHost() || poll.ownerId === this.attendantId;
        }

        function editPollHasChanges() {
            var self = this;
            return (
                self.editPollModel.editQuestion !== self.pollBeingEdited.pollTopic ||
                self.editPollModel.editAnswer1 !== self.pollBeingEdited.options[0].text ||
                self.editPollModel.editAnswer2 !== self.pollBeingEdited.options[1].text ||
                self.editPollModel.editAnswer3 !== self.pollBeingEdited.options[2].text ||
                self.editPollModel.editAnswer4 !== self.pollBeingEdited.options[3].text ||
                self.editPollModel.editAnswer5 !== self.pollBeingEdited.options[4].text
            );
        }

        function cancelEditedPoll() {
            var self = this;

            // Cancel new poll
            logger.log('cancelEditedPoll');

            if (self.editPollHasChanges()) {
                $window.swal(
                    {
                        title: localizationService.translate('POLLS.DISCARD_CHANGES.TITLE'),
                        type: 'warning',
                        showCancelButton: true,
                        cancelButtonText: localizationService.translate('COMMON.CANCEL_TEXT'),
                        confirmButtonColor: brandingService.getBaseColor(),
                        confirmButtonText: localizationService.translate('POLLS.DISCARD'),
                        closeOnConfirm: true
                    },
                    function (isConfirm) {
                        if (isConfirm) {
                            logger.log('Call to discard changes to this poll was confirmed');

                            self.changeView('list');

                            self.clearEditPollFields();
                        } else {
                            logger.log('Call to discard changes to this poll was cancelled');
                        }
                    }
                );
            } else {
                self.changeView('list');
            }
        }

        function changeView(newView) {
            switch (newView) {
                case 'list':
                case 'create':
                case 'edit':
                    self.currentView = newView;
                    break;
                default:
                    // Ignore
                    break;
            }

            digest();
        }

        function clearCreatePollFields() {
            self.createPollModel.createQuestion = '';
            self.createPollModel.createAnswer1 = '';
            self.createPollModel.createAnswer2 = '';
            self.createPollModel.createAnswer3 = '';
            self.createPollModel.createAnswer4 = '';
            self.createPollModel.createAnswer5 = '';
        }

        function clearEditPollFields() {
            self.pollBeingEdited = null;
            self.editPollModel.editPollId = null;
            self.editPollModel.editQuestion = '';
            self.editPollModel.editAnswer1 = '';
            self.editPollModel.editAnswer2 = '';
            self.editPollModel.editAnswer3 = '';
            self.editPollModel.editAnswer4 = '';
            self.editPollModel.editAnswer5 = '';
        }

        function createPoll() {
            // Open create view
            logger.log('createPoll');

            self.changeView('create');
        }

        function createPollIsValid() {
            if (
                self.createPollModel.createQuestion &&
                self.createPollModel.createAnswer1 &&
                self.createPollModel.createAnswer2
            ) {
                return true;
            } else {
                return false;
            }
        }

        function submitNewPoll() {
            if (self.createPollIsValid()) {
                pollingService.addNewPoll(
                    self.createPollModel.createQuestion,
                    self.createPollModel.createAnswer1,
                    self.createPollModel.createAnswer2,
                    self.createPollModel.createAnswer3,
                    self.createPollModel.createAnswer4,
                    self.createPollModel.createAnswer5
                );
            } else {
                // Create poll is not valid
                $window.swal({
                    title: localizationService.translate('POLLS.ADD_ANSWERS.TITLE'),
                    text: localizationService.translate('POLLS.ADD_ANSWERS.TEXT'),
                    confirmButtonColor: brandingService.getBaseColor(),
                    type: 'warning'
                });
            }
        }

        function editPollIsValid() {
            if (self.editPollModel.editQuestion && self.editPollModel.editAnswer1 && self.editPollModel.editAnswer2) {
                return true;
            } else {
                return false;
            }
        }

        function submitEditedPoll() {
            if (self.editPollIsValid()) {
                if (self.editPollHasChanges()) {
                    pollingService.updateExistingPoll(
                        self.pollBeingEdited.pollId,
                        self.editPollModel.editQuestion,
                        self.editPollModel.editAnswer1,
                        self.editPollModel.editAnswer2,
                        self.editPollModel.editAnswer3,
                        self.editPollModel.editAnswer4,
                        self.editPollModel.editAnswer5
                    );
                } else {
                    // Edit poll has no changes
                    $window.swal({
                        title: localizationService.translate('POLLS.NO_CHANGES.TITLE'),
                        confirmButtonColor: brandingService.getBaseColor(),
                        type: 'warning'
                    });
                }
            } else {
                // Edit poll is not valid
                $window.swal({
                    title: localizationService.translate('POLLS.EDIT_NOT_VALID_ADD_ANSWERS.TITLE'),
                    text: localizationService.translate('POLLS.EDIT_NOT_VALID_ADD_ANSWERS.TEXT'),
                    confirmButtonColor: brandingService.getBaseColor(),
                    type: 'warning'
                });
            }
        }

        function editPoll(poll) {
            if (pollingService.getIsVoting() && pollingService.getActivePoll().pollId === poll.pollId) {
                $window.swal({
                    title: localizationService.translate('POLLS.CANT_START_RUNNING_POLL.TITLE'),
                    text: localizationService.translate('POLLS.CANT_START_RUNNING_POLL.TEXT'),
                    confirmButtonColor: brandingService.getBaseColor(),
                    type: 'warning'
                });
            } else {
                // Open edit view with poll.pollId
                logger.log('editPoll pollId: ' + poll.pollId);

                self.pollBeingEdited = poll;

                self.editPollModel.editPollId = poll.pollId;
                self.editPollModel.editQuestion = poll.pollTopic;
                self.editPollModel.editAnswer1 = poll.options[0].text;
                self.editPollModel.editAnswer2 = poll.options[1].text;
                self.editPollModel.editAnswer3 = poll.options[2].text;
                self.editPollModel.editAnswer4 = poll.options[3].text;
                self.editPollModel.editAnswer5 = poll.options[4].text;

                self.changeView('edit');
            }
        }

        function deletePoll(poll) {
            if (pollingService.getIsVoting() && pollingService.getActivePoll().pollId === poll.pollId) {
                $window.swal({
                    title: localizationService.translate('POLLS.CANT_DELETE_RUNNING_POLL.TITLE'),
                    text: localizationService.translate('POLLS.CANT_DELETE_RUNNING_POLL.TEXT'),
                    confirmButtonColor: brandingService.getBaseColor(),
                    type: 'warning'
                });
            } else {
                $window.swal(
                    {
                        title: localizationService.translate('POLLS.ARE_YOU_SHURE_DELETE.TITLE'),
                        text: poll.pollTopic,
                        type: 'warning',
                        showCancelButton: true,
                        cancelButtonText: localizationService.translate('COMMON.CANCEL_TEXT'),
                        confirmButtonColor: brandingService.getBaseColor(),
                        confirmButtonText: localizationService.translate('COMMON.YES_TEXT'),
                        closeOnConfirm: true
                    },
                    function (isConfirm) {
                        if (isConfirm) {
                            pollingService.deleteExistingPoll(poll.pollId);
                        } else {
                            logger.log('Call to delete poll was cancelled');
                        }
                    }
                );
            }
        }

        function runPoll(poll, pollsIndex) {
            if (meetingService.getIsOnAir() === false) {
                $window.swal({
                    title: localizationService.translate('POLLS.CANT_START_OFF_AIR.TITLE'),
                    text: localizationService.translate('POLLS.CANT_START_OFF_AIR.TEXT'),
                    confirmButtonColor: brandingService.getBaseColor(),
                    type: 'warning'
                });
            } else if (pollingService.getIsVoting()) {
                $window.swal({
                    title: localizationService.translate('POLLS.CANT_START_DURING_POLL.TITLE'),
                    text: localizationService.translate('POLLS.CANT_START_DURING_POLL.TEXT'),
                    confirmButtonColor: brandingService.getBaseColor(),
                    type: 'warning'
                });
            } else if (contentService.isContentPlaying() && contentService.getContentType() === 'screenshare') {
                $window.swal({
                    title: localizationService.translate('POLLS.CANT_START_DURING_SCREENSHARE.TITLE'),
                    text: localizationService.translate('POLLS.CANT_START_DURING_SCREENSHARE.TEXT'),
                    confirmButtonColor: brandingService.getBaseColor(),
                    type: 'warning'
                });
            } else if (contentService.isContentPlaying() && contentService.getContentType() === 'video') {
                $window.swal({
                    title: localizationService.translate('POLLS.CANT_START_DURING_VIDEO.TITLE'),
                    text: localizationService.translate('POLLS.CANT_START_DURING_VIDEO.TEXT'),
                    confirmButtonColor: brandingService.getBaseColor(),
                    type: 'warning'
                });
            } else if (questionService.getIsInQandAMode()) {
                $window.swal({
                    title: localizationService.translate('POLLS.CANT_START_DURING_QAND.TITLE'),
                    confirmButtonColor: brandingService.getBaseColor(),
                    type: 'warning'
                });
            } else {
                pollingService.startVoting(self.attendantLoginId, poll.pollId, pollsIndex);
            }
        }

        function stopVoting() {
            pollingService.stopVoting(self.attendantLoginId, self.pollRunning.pollId);
        }

        function donePolling() {
            pollingService.closePolling();
            self.onHideModal('donePolling', 'pollsModalCtrl as polls');
        }

        function pollAnswerSelected(index) {
            // Answer selected to running poll
            logger.log('pollAnswerSelected pollId: ' + self.pollRunning.pollId + ', index: ' + index);
            self.pollRunningSelectedPollId = index;
        }

        function getVotePercentage(votes, totalVotes) {
            var percentage = Math.round((votes / totalVotes) * 100);

            if (!percentage || percentage < 0 || percentage === Infinity) {
                percentage = 0;
            }

            return percentage + '%';
        }

        function getTotalVotes(poll) {
            return (
                (poll.options[0].votes > 0 ? poll.options[0].votes : 0) +
                (poll.options[1].votes > 0 ? poll.options[1].votes : 0) +
                (poll.options[2].votes > 0 ? poll.options[2].votes : 0) +
                (poll.options[3].votes > 0 ? poll.options[3].votes : 0) +
                (poll.options[4].votes > 0 ? poll.options[4].votes : 0)
            );
        }
    }
]);
